import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Col, Container, Modal, Row, Pagination } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import BuyNft from "./BuyNft";
import { PaginationItem, PaginationLink } from "reactstrap";
import { allsellItemNFtCount, getAlltransaction, getArtNotificationsRequest, getArtworkForm, getParticularSellItem, getPrinterFromProduct, getviewCountOwner, likeViewSellItem, postNotificationRequest, sellItemFromCollectionId, getCanvasPaperSize } from "store/actions";
import { Oval } from 'react-loader-spinner'
import { converCryptoToDollar, coversion } from "helpers/constants";
import PreviewNFT from "./PreviewNFT";
import Share from "./Share";
import { Helmet } from "react-helmet";
import toastr from "toastr";
import { FetchCityListdata, FetchCountryListdata, FetchStateListdata } from "helpers/fetch_country_state_helper";
import Currency from "Component/Currency/Currency";
import PaywithCard from "./PaywithCard";
// import CheckoutForm from "Component/CheckoutComponent/CheckoutForm";

// View NFT
export default function NftSale(props) {
  const adminPercentage = Number(process.env.REACT_APP_ADMIN_PRINT_PERCENT)
  const artistPercentage = Number(process.env.REACT_APP_ARTIST_PRINT_PERCENT)
  const dispatch = useDispatch()
  const [buyDialog, setbuyDialog] = useState(false)
  const [viewnftDialog, setviewnftDialog] = useState(false)
  const [paywithcard, setpaywithcard] = useState(false)
  const location = useLocation()
  const [isPhysicalArt, setisPhysicalArt] = useState(false)

  useEffect(() => {
    if (location?.state?.isPhysical === true) {
      const isPhysical = location?.state?.isPhysical;
      setisPhysicalArt(isPhysical);
      console.log('isPhysical from location.state:', location);
    }


  }, [location])

  const params = useParams()
  const current_userId = useSelector((state) => state?.Login?.user?._id)
  const { item } = useSelector((x) => x?.items)
  const { user } = useSelector((state) => state?.Login);
  const { authToken } = useSelector((state) => state?.Login)
  const { sellItem, allSellItemNftCounts, canvasPaperSizes } = useSelector((x) => x?.SellItems)
  const { likedUsersId } = useSelector((x) => x?.SellItems?.sellItem)
  const { id } = params
  // const user_id = useSelector((s) => s.Login?.user?._id)
  const user_id = JSON.parse(localStorage.getItem("authUser"))?.data?.user_id
  const [isLiked, setIsLiked] = useState(false)
  const [like, setLike] = useState(false)
  const [likeColor, setLikeColor] = useState(false)
  var [likeCount, setLikeCount] = useState(0)
  const [saledatasend, setSaledatasend] = useState({ discountnft: false, sell_id: "", nftid: "", owneraddress: "", tokenId: 0, url: "", nftname: "", userid: "", price: 0, copies: 0, avalable: 0 })
  const { sellItemFromCollectionID } = useSelector((state) => state?.SellItems);
  const { Printers } = useSelector((state) => state?.Print);
  const [recall, setRecall] = useState(false)
  const [loading2, setLoading2] = useState(true)
  const [nftId, setNftId] = useState('')
  const { transactions } = useSelector((state) => state?.Transactions);
  const [data, setData] = useState({})
  const [sellItemFromCollectionData, setSellItemFromCollectionData] = useState([])
  const [usdPrice, setUsdPrice] = useState(0);

  const [empty, setEmpty] = useState(true)
  const [isDigital, setIsDegital] = useState('Digital');
  const [selectedPrinterId, setSelectedPrinterId] = useState('')
  const [paperSizes, setPaperSizes] = useState([])
  const [timezone, setTimezone] = useState()
  const [printInfo, setPrintInfo] = useState({
    nft_price: 0,
    printStyle: "P;hysical with Crypto",
    size: "24 x 24",
    canvas_type: "A1",  // canvas type and paper type both data storing in the canvas type
    country: { name: "", code: "" },
    address: "",
    landmark: "",
    pincode: "",
    city: "",
    state: { name: "", code: "" },
    partner_id: "",
    print_charge: 0,
    tax: 0,
    user_id: user_id,
    nft_id: '',
    discount: 0,
    tax_percentage: 0,
    total_amount: 0,
    admin_commission: 0,
    seller_earning: 0,
    partner_earning: 0,
    total_cost: 0,
    print_option: "Paper",
    is_spray: true,
    admin_earning: 0,
    printer_earning: 0,
    printer_alone_charge: 0,
    spray_cost_per_inch: 0,
    serving_areas: [{ name: "", price: "", state: [] }],
    premium_charge: 0,
    total_cost_matic: 0,
    owner_id: ''
  })
  const [symbol, setSymbol] = useState("$");
  const [convertIntoCurrency, setConvertIntoCurrency] = useState("USD")
  const sizes = ['24 x 24', '12 x 12', '10 x 10', '20 x 24', '8 x 10', '40 x 50', '45 x 60', '50 x 60', '50 x 75'];
  const [printerChargeMatic, setPrinterChargeMatic] = useState(0)
  const [ownerPriceMatic, setOwnerPriceMatic] = useState(0)
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [citites, setCities] = useState([]);
  const [sizeOption, setSizeOption] = useState()
  const [sizeOptions, setSizeOptions] = useState([])
  const [showNFT, setshowNFT] = useState(false);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  useEffect(() => {
    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(timezoneString)
  }, [])

  useEffect(() => {
  }, [sizeOption, paperSizes]);
  const ViewNFT = () => {
    setshowNFT(!showNFT);
  };
  useEffect(() => {

    if (sellItem?.nft_id?._id) {
      dispatch(getArtworkForm({ nft_id: sellItem?._id }))
    }

  }, [sellItem, dispatch])
  // ENd View NFT
  useEffect(() => {
    if (user_id) {
      setPrintInfo((p) => ({ ...p, user_id: user_id }))
    }

  }, [user_id])

  useEffect(() => {
    function isEmpty(obj) {
      for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
          return false;
        }
      }
      return true;
    }
    setEmpty(isEmpty(sellItem))
  }, [sellItem])
  useEffect(() => {
    const x = sellItemFromCollectionID.filter((item) => item.sellType === "fixed")
    setSellItemFromCollectionData(x)
  }, [sellItemFromCollectionID])
  useEffect(() => {
    if (sellItem) {
      let body = {}
      body.user_id = sellItem?.owner_id?._id
      body.sellitem_id = id
      dispatch(getAlltransaction(body))

    }
  }, [id, sellItem, user_id, dispatch])
  useEffect(() => {
    if (nftId && sellItem) {
      dispatch(getviewCountOwner(sellItem?.nft_id?._id))

      // sahil 
    }
  }, [nftId, dispatch,])
  useEffect(() => {
    if (empty) {
      setLoading2(false)
    } else {
      setLoading2(true)
    }
  }
    , [empty])
  const [loading3, setLaoding3] = useState(true)

  useEffect(() => {
    if (sellItem) {
      if (sellItem?.owner_id) {
        let body = {}
        body.id = sellItem?.owner_id?._id
        dispatch(allsellItemNFtCount(body))
        setLaoding3(false)
      }
      setNftId(sellItem?.nft_id?._id)

      if (sellItem?.likedUsersId?.includes(current_userId)) {
        setLike(false)
        setLaoding3(false)
      }
    }


  }, [sellItem])

  useEffect(() => {
    if (sellItem) {
      dispatch(sellItemFromCollectionId(id))
    }
  }, [id, dispatch, sellItem])
  useEffect(() => {
    setLoading2(true)
    setLikeCount(item?.like_count)
    if (likedUsersId?.filter((x) => x === user_id)?.length > 0) {
      setLike(false)
      setLikeColor(true)
    } else {
      setLike(true)
      setLikeColor(false)
    }
    setLoading2(false)
  }, [likedUsersId, user_id, recall])
  useEffect(() => {
    setLoading2(true)
    if (like) {
      setLike(false)
      setLikeCount(++likeCount)
      setLikeColor(true)
    }
    else {
      setLikeColor(false)
      setLike(true)
      setLikeCount(--likeCount)
    }
    setLoading2(false)
  }, [recall])

  async function getellItem(id) {
    setLaoding3(true)
    const callback = (res) => {
      setLaoding3(false)
    }
    dispatch(getParticularSellItem(id, callback))
  }

  useEffect(() => {
    getellItem(id)
  }, [id])
  // sahil 


  useEffect(() => {
    if (sellItem && id && user_id) {
      data.user_id = user_id
      data.nft_id = id
      data.isLiked = isLiked
      data.likeStatus = like
      const callback = (res) => {
        if (res.status === "success") {
          setLoading2(false)
          setData(res.data)
          if (res?.data?.likedUsersId.includes(user?._id) && (res?.data?.owner_id !== user?._id)) {

            if (res?.data?.owner_id) {
              let data = {}
              data.sender = process.env.REACT_APP_ADMIN_ID
              data.receiver = res?.data?.owner_id
              data.is_read = false
              data.type = "like"
              data.sellItemId = sellItem?._id
              data.content = `${user?.name + " " + user?.lastname} has liked your ${sellItem?.nft_id?.name} NFT!.`
              dispatch(postNotificationRequest(data, (res) => {
                if (user?._id) {
                  let notificationData = {}
                  notificationData.receiver = user?._id
                  const notificationCallback = (res) => {
                  }
                  dispatch(getArtNotificationsRequest(notificationData, notificationCallback))

                }
              }));
            }
          }
        } else {
          setLoading2(false)
        }
      }
      dispatch(likeViewSellItem(data, callback))
      setLoading2(false)
    }

  }, [recall])
  const handleLikeView = (name) => {
    if (user_id) {
      if (name) {
        setIsLiked(true)
        setRecall(!recall)

      }
      else {
        setIsLiked(!isLiked)
        setRecall(!recall)
      }
    }

  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const calPrice = async () => {
        let amount = Number(sellItem?.price);
        let symbol = "MATIC";
        let data = await converCryptoToDollar(amount, symbol, convertIntoCurrency);
        setUsdPrice((pre) => ({
          ...pre,
          data,
        }));
      };
      calPrice({ price: sellItem?.price });
    }, 300);
    return () => clearTimeout(delayDebounceFn);

  }, [sellItem, convertIntoCurrency]);

  useEffect(() => {
    console.log('usdPrice', usdPrice);

  }, [usdPrice])

  const mapCUrrenccyConvertor = async (price) => {

    let data = await converCryptoToDollar(price, "MATIC", convertIntoCurrency);
    console.log("afsdfasdzxcvvsdafasefa", data)
    return data
  }

  const conversionFunc = async (amountPrice, from, to) => {
    let data = await coversion(amountPrice, from, to);
    return data
  };

  const buynowBtn = () => {

    if (isDigital != "Digital") {
      if (!printInfo.printStyle) return toastr.error("Buying option is required")
      if (!printInfo.size) return toastr.error("Size is required")
      // if (!printInfo.canvas_type) return toastr.error("Option is required")
      if (!printInfo.address) return toastr.error("Address is required")
      if (!printInfo.landmark) return toastr.error("Landmark is required")
      if (!printInfo.pincode) return toastr.error("Pincode is required")
      if (!printInfo.city) return toastr.error("City is required")
      if (!printInfo.state) return toastr.error("State is required")
      if (!printInfo.user_id) return toastr.error("User Id is required")
      if (printInfo.partner_id === "") return toastr.error("Please Select Printer")
      if (!printInfo.nft_id) return toastr.error("Digital Artwork Id is required")

      if (isDigital === "Physical with Crypto" || isDigital === "Digital+Physical") {

        setbuyDialog(!buyDialog)
      } else if (isDigital === "Physical with Credit Card") {

        setIsCheckoutOpen(true)
      }
    }
    setSaledatasend({
      discountnft: sellItem?.discount, collection_id: sellItem?.collection_id, creator_id: sellItem?.nft_id?.author_id, selleruser_id: sellItem?.owner_id?._id, sell_id: sellItem?._id, nftid: sellItem?.nft_id?._id, owneraddress: sellItem?.creator_wallet, tokenId: sellItem?.nft_id?.token_id, url: sellItem?.nft_id?.publicUrl, nftname: sellItem?.nft_id?.name, userid: user?._id, price: sellItem?.price, copies: sellItem?.no_of_copies, avalable: sellItem?.available_copies, royalties: sellItem?.loaylty, premium_print_cost: sellItem?.premium_print_cost
    })
    if (isDigital == "Digital") {
      setbuyDialog(!buyDialog)
    }

  };

  const printOption = (event, size) => {
    setOwnerPriceMatic(0)
    setPrinterChargeMatic(0)

    if (event === "Paper") {
      setPrintInfo((p) => ({ ...p, print_option: event, canvas_type: paperSizes[0], is_spray: true, partner_id: '', total_cost: 0, total_cost_matic: 0 }))
    } else {
      setPrintInfo((p) => ({
        ...p, print_option: event, canvas_type: "",


        size: "24 x 24", is_spray: true, partner_id: '', total_cost: 0, total_cost_matic: 0
      }))
    }
  }
  useEffect(() => {
    if (user_id) {
      setPrintInfo((p) => ({ ...p, user_id: user_id }))
    }
  }, [user_id])
  useEffect(() => {
    if (printInfo.country || printInfo.state) {
      let data = {}
      data.type = printInfo?.print_option
      data.size = printInfo.size
      data.canvas_type = printInfo.canvas_type
      data.country = printInfo?.country?.name
      data.state = printInfo?.state?.name
      dispatch(getPrinterFromProduct(data))
    }
  }, [printInfo?.print_option, printInfo.size, printInfo.canvas_type, printInfo?.country?.name, printInfo?.state?.name, printInfo?.printStyle])



  useEffect(() => { console.log("adfasdfasdf", printInfo) }, [printInfo])

  const [nftlink, setNftLink] = useState()
  const viewnftBtn = (data) => {
    setviewnftDialog(!viewnftDialog)
    setNftLink(data)
  }

  const paywithCardftBtn = (data) => {
    setpaywithcard(!paywithcard)
  }


  // pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);


  useEffect(() => {

    if (transactions?.length < 9) {
      setDataLength([1]);
    } else {
      const x = Math.ceil(transactions.length / 10);
      const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
      setDataLength(newLengthArray);
    }

  }, [transactions]);

  useEffect(() => {
    let arr = [];

    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (transactions[i]) {

        arr.push(transactions[i]);
      }
    }
    setDataAfterPagination(arr);
  }, [values, transactions, dataLength]);

  const handlePagination = (val) => {
    let valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = Math.max(0, values - 10);
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < transactions.length) {
      valu = Math.ceil(transactions.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };
  const [readMore, setReadmore] = useState(false)
  const readmore = () => {
    setReadmore(!readMore)
  }
  const [bgimage, setbgimage] = useState()
  useEffect(() => {
    setbgimage("url(" + (user?._id && user?._id === sellItem?.owner_id?._id) ? sellItem?.nft_id?.image_id?.image?.link : sellItem?.nft_id?.image_id?.image?.water_mark_image_link ? sellItem?.nft_id?.image_id?.image?.water_mark_image_link : sellItem?.nft_id?.image_id?.image?.link + ")")
  }, [user, sellItem])
  // =================================== print start ======================================
  useEffect(() => {
    setPrintInfo((p) => ({
      ...p,
      user_id: user_id,
      nft_id: nftId,
      nft_price: sellItem?.price,
    }));
  }, [user_id, nftId, sellItem]);

  const checkVerient = (data) => {
    setIsDegital(data);
    setOwnerPriceMatic(0);
    setPrinterChargeMatic(0);

    setPrintInfo((p) => ({
      ...p,
      printStyle: data,
      nft_price: 0,
      size: "24 x 24",
      canvas_type: "A1",
      country: { name: "", code: "" },
      address: "",
      landmark: "",
      pincode: "",
      city: "",
      state: { name: "", code: "" },
      partner_id: "",
      print_charge: 0,
      tax: 0,
      discount: 0,
      tax_percentage: 0,
      total_amount: 0,
      admin_commission: 0,
      seller_earning: 0,
      partner_earning: 0,
      total_cost: 0,
      print_option: "Paper",
      premium_charge: 0,
      is_spray: true,
      user_id: user_id,
    }));
  };

  const handleOnChangePrintInfo = (name, value) => {
    setSelectedPrinterId("");

    setPrintInfo((p) => {
      if (name === "country") {
        const countryInfo = countries.find((c) => c.code === value) || { name: "", code: "" };
        return { ...p, country: countryInfo, state: { name: "", code: "" }, city: "", partner_id: '', total_cost: 0 };
      }

      if (name === "state") {
        const stateInfo = states.find((s) => s.code === value) || { name: "", code: "" };
        return { ...p, state: stateInfo, city: "", partner_id: '', total_cost: 0 };
      }

      return { ...p, [name]: value, partner_id: '', print_charge: 0, tax: 0, total_cost: 0 };
    });
  };


  const extractStatePrice = (x) => {
    const prices = x.serving_areas.flatMap((area) =>
      area.state?.filter((s) => s.name === printInfo?.state?.name)?.map((s) => Number(s.price))
    );
    return prices.length > 0 ? Number(prices[0]) : null;
  };

  const handlePriceWithSpray = async (x) => {
    const statePrice = extractStatePrice(x);
    if (printInfo?.print_option === "Canvas") {
      if (printInfo?.print_option !== "Canvas" || !printInfo?.is_spray || !x?.canvases?.length) return null;

      for (const y of x.canvases) {
        // if (!y.sizes.includes(printInfo.size)) continue;

        const sizeParts = printInfo?.size?.split(" ");
        if (sizeParts.length < 3) {
          console.error("Invalid size format.");
          return null;
        }

        const width = Number(sizeParts[0]);
        const height = Number(sizeParts[2]);
        const statePrice = extractStatePrice(x);
        if (statePrice === null) {
          console.error("No state price found.");
          return null;
        }
        let canvasInkCost = 0;
        if (x?.ink_price && x?.ink_size) {
          const sizeString = printInfo?.size
          const [width, height] = sizeString.split(" x ").map(Number);

          canvasInkCost = (width * height) * Number(x?.ink_price);
        }

        const basePrice = width * height * Number(y.price);


        const sprayCost = Number(x.spray_cost_per_inch) * width * height;

        const totalPrinterCharge = sprayCost + statePrice + basePrice + canvasInkCost;
        console.log("spraycost", sprayCost, "basePrice", basePrice, "statePrice", statePrice, "canvasInkCost", canvasInkCost)


        const priceWithCommission = totalPrinterCharge + totalPrinterCharge * (adminPercentage + artistPercentage) / 100;
        const exchangePrice = await converCryptoToDollar(priceWithCommission, "USD", convertIntoCurrency)
        return {
          printer_charge: Number(totalPrinterCharge),
          price: Number(exchangePrice).toFixed(6),
        };
      }

      return null;
    } else if (printInfo?.print_option === "Paper") {
      for (const paper of x.papers || []) {
        if (paper.name !== printInfo?.canvas_type) continue;

        const totalPrinterCharge = Number(paper.price) + statePrice;
        const priceWithCommission = totalPrinterCharge + totalPrinterCharge * (adminPercentage + artistPercentage) / 100;
        const exchangePrice = await converCryptoToDollar(priceWithCommission, "USD", convertIntoCurrency)
        return {
          printer_charge: Number(totalPrinterCharge),
          price: Number(exchangePrice).toFixed(6),
        };
      }
    }
  };


  const handlePrice = async (x) => {
    const statePrice = extractStatePrice(x);
    if (statePrice === null) {
      console.error("No state price found.");
      return null;
    }


    if (printInfo?.print_option === "Canvas" && !printInfo?.is_spray) {

      for (const y of x.canvases || []) {
        // if (!y.sizes.includes(printInfo.size)) continue;

        const sizeParts = printInfo?.size?.split(" ");
        if (sizeParts.length < 3) {
          console.error("Invalid size format.");
          return null;
        }

        const width = Number(sizeParts[0]);
        const height = Number(sizeParts[2]);
        const basePrice = width * height * y.price;
        let canvasInkCost = 0;
        if (x?.ink_price && x?.ink_size) {
          const sizeString = printInfo?.size

          const [width, height] = sizeString.split(" x ").map(Number);

          canvasInkCost = (width * height) * Number(x?.ink_price);
        }
        console.log("canvasInkCost", width, height, canvasInkCost, x.ink_price, basePrice)

        const totalPrinterCharge = statePrice + basePrice;

        const priceWithCommission = totalPrinterCharge + totalPrinterCharge * (adminPercentage + artistPercentage) / 100;
        console.log("priceWithCommission", priceWithCommission)
        const exchangePrice = await converCryptoToDollar(priceWithCommission, "USD", convertIntoCurrency)
        // console.log("priceWithCommission", priceWithCommission)
        return {
          printer_charge: Number(totalPrinterCharge),
          price: Number(exchangePrice).toFixed(6),
        };
      }
    } else {
      for (const paper of x.papers || []) {
        if (paper.name !== printInfo?.canvas_type) continue;

        const totalPrinterCharge = Number(paper.price) + statePrice;
        const priceWithCommission = totalPrinterCharge + totalPrinterCharge * (adminPercentage + artistPercentage) / 100;
        const exchangePrice = await converCryptoToDollar(priceWithCommission, "USD", convertIntoCurrency)
        return {
          printer_charge: Number(totalPrinterCharge),
          price: Number(exchangePrice).toFixed(6),
        };
      }
    }

    return null;
  };
  const [alltotalPriceInMatic, setAllTotalPriceInMatic] = useState()
  const [totalConvertedPrice, setTotalCOnvertedPrice] = useState()
  const handlePrinterSelect = async (item) => {
    try {
      // Get price data (with or without spray)
      const isSpray = printInfo?.is_spray;
      const priceData = isSpray ? await handlePriceWithSpray(item) : await handlePrice(item);
      console.log(32434234234, priceData)
      if (!priceData) return;

      const printerPrice = Number(priceData.price);
      const printerCharge = Number(priceData.printer_charge);

      // Update print info and selected printer
      setSelectedPrinterId(item?._id);
      setPrintInfo((prev) => ({
        ...prev,
        total_cost: printerPrice,
        partner_id: item._id,
        printer_alone_charge: printerCharge,
      }));

      // Convert only once using the printerPrice (already fetched)
      console.log(432234526565, printerPrice)
      const convPrice1 = await converCryptoToDollar(printerPrice, convertIntoCurrency, "USD");
      const convPrice2 = await converCryptoToDollar(Number(Number(printInfo?.premium_charge).toFixed(6), "MATIC", "USD"));
      setPrintInfo((prev) => ({
        ...prev,
        print_charge: Number(Number(convPrice1).toFixed(2)) + Number(Number(convPrice2).toFixed(4))
      }));
      const convPrice = await converCryptoToDollar(Number(convPrice1), "USD", "MATIC");
      const convPriceNumber = Number(convPrice);
      setPrinterChargeMatic(convPriceNumber);


      // Calculate final total in MATIC
      const totalMatic = convPriceNumber + Number(printInfo.tax || 0) + Number(sellItem?.premium_print_cost || 0);
      setAllTotalPriceInMatic(totalMatic);

      // Convert final total into selected currency
      const totalConverted = await converCryptoToDollar(totalMatic, "MATIC", convertIntoCurrency);
      setTotalCOnvertedPrice(Number(totalConverted));
    } catch (error) {
      console.error("Error in handlePrinterSelect:", error);
    }
  };


  useEffect(() => {
    const calc = async () => {
      let fromCurrency = "USD"
      let fromPrice = totalConvertedPrice
      if (convertIntoCurrency === "USD") {
        fromCurrency = "MATIC";
        fromPrice = alltotalPriceInMatic
      }
      const TotalconvPrice = await converCryptoToDollar(alltotalPriceInMatic, "MATIC", convertIntoCurrency)
      setTotalCOnvertedPrice(Number(TotalconvPrice))
      // const [alltotalPriceInMatic, setAllTotalPriceInMatic] = useState()
      // const [totalConvertedPrice, setTotalCOnvertedPrice] = useState()
    }
    calc()
  }, [symbol, convertIntoCurrency])

  useEffect(() => {
    if (!printInfo?.partner_id) {
      // setTotalPolPrice(0);
      setPrintInfo((p) => ({ ...p, total_cost_matic: 0 }))
      setPrinterChargeMatic(0);


    }
  }, [printInfo?.partner_id]) //sahil

  useEffect(() => {
    const calculateTotalPrice = async () => {

      if (!printInfo?.partner_id) return;

      const premiumCost = Number(sellItem?.premium_print_cost) || 0;
      const tax = Number(printInfo?.tax) || 0;
      const nftPrice = (printInfo?.printStyle === "Digital" || printInfo?.printStyle === "Digital+Physical") ? Number(sellItem?.price) : 0;
      try {
        let convertedCharge = await conversionFunc(Number(printInfo?.print_charge), "USD", "MATIC");

        convertedCharge = Number(convertedCharge);

        const totalPriceMatic = nftPrice + tax + convertedCharge + premiumCost;
        const totalPriceDollar = await conversionFunc(totalPriceMatic, "MATIC", "USD");

        setOwnerPriceMatic(convertedCharge * (artistPercentage / 100) + premiumCost);

        setPrintInfo((p) => ({
          ...p,
          total_cost: totalPriceDollar,
          total_cost_matic: totalPriceMatic,
          premium_charge: premiumCost,
        }));
      } catch (error) {
        console.error("Error calculating total price:", error);
      }
    };

    calculateTotalPrice();
  }, [
    printInfo?.printStyle,
    sellItem?.price,
    printInfo?.tax,
    sellItem?.premium_print_cost,
    printInfo?.print_charge,
    printInfo?.is_spray,
    printInfo?.print_option,
    printInfo?.partner_id,
  ]);

  useEffect(() => {
    if (printInfo?.partner_id === '') {
      setOwnerPriceMatic();
    }
  }, [printInfo]);



  useEffect(() => {
    setTotalCOnvertedPrice(0)
    setAllTotalPriceInMatic(0)
  }, [printInfo?.print_option, printInfo?.size])

  // ==================================== print end ========================================

  const fucntionToFetchCountries = async () => {
    let country = await FetchCountryListdata()
    setCountries(country)
  }
  const fucntionToFetchStates = async (code) => {
    let statesdata = await FetchStateListdata(code)
    setStates(statesdata)
  }
  const fucntionToFetchCities = async (countryCode, stateCode) => {
    let citiesData = await FetchCityListdata(countryCode, stateCode)
    setCities(citiesData)
  }
  useEffect(() => {
    fucntionToFetchCountries()
  }, [])

  useEffect(() => {
    if (printInfo?.country?.code !== '') {
      fucntionToFetchStates(printInfo?.country?.code)
    }
    if (printInfo?.state?.code !== '' && printInfo?.country?.code !== '') {
      fucntionToFetchCities(printInfo?.country?.code, printInfo?.state?.code)
    }
  }, [printInfo.country, printInfo.state])

  useEffect(() => {
    if (printInfo?.country?.name && printInfo?.state?.name) {
      dispatch(getCanvasPaperSize({ country: printInfo?.country?.name, state: printInfo?.state?.name }))
    }
  }, [printInfo?.country?.name && printInfo?.state?.name])


  useEffect(() => {
    if (Array.isArray(canvasPaperSizes?.papersName) && canvasPaperSizes.papersName.length > 0) {
      setPaperSizes(canvasPaperSizes.papersName.filter(name => name?.trim() !== ""));
    }
    if (Array.isArray(canvasPaperSizes?.canvasesName) && canvasPaperSizes.canvasesName.length > 0) {
      setSizeOptions(sizes);
    }
  }, [canvasPaperSizes]);


  // code end

  const setCurrnencyTobeConverted = (currency, symbol) => {
    setConvertIntoCurrency(currency)
    setSymbol(symbol)
  }
  const [printerPrices, setPrinterPrices] = useState({});
  useEffect(() => {
    const calculatePrices = async () => {
      const prices = {};
      for (const item of Printers) {
        const priceInfo = printInfo?.is_spray === false
          ? await handlePrice(item)
          : await handlePriceWithSpray(item);

        prices[item._id] = priceInfo?.price || 0;
        // setPrintInfo((p) => ({ ...p, print_charge: priceInfo?.price }))
      }
      setPrinterPrices(prices);
    };
    // sahil123

    if (Printers.length > 0 && printInfo) {
      calculatePrices();
    }
  }, [Printers, printInfo.is_spray, symbol, convertIntoCurrency]);


  // const totalPolPriceConversion = async()=>{
  //   setTotalPolPrice( await converCryptoToDollar(Number(printInfo?.total_cost_matic), "MATIC", convertIntoCurrency))
  // }



  // useEffect(()=>{

  //   totalPolPriceConversion()
  // }, [printInfo?.total_cost_matic])



  useEffect(() => {
    console.log("isDigital", isDigital, "isCheckoutOpen", isCheckoutOpen, "buyDialog", buyDialog, "printInfo", printInfo)
  }, [isDigital, isCheckoutOpen, buyDialog, printInfo])
  const [convertedItems, setConvertedItems] = useState([]);

  useEffect(() => {
    const fetchConvertedPrices = async () => {
      if (!sellItemFromCollectionData) return;

      const updated = await Promise.all(
        sellItemFromCollectionData.map(async (item) => {
          const convertedPrice = await mapCUrrenccyConvertor(Number(item?.price));
          return { ...item, convertedPrice };
        })
      );
      setConvertedItems(updated);
    };

    fetchConvertedPrices();
  }, [sellItemFromCollectionData, convertIntoCurrency]);

  const payWithCraditCard = () => {
    alert()
  }


  return (
    <>
      <Helmet>
        <meta property="og:title" content={sellItem?.nft_id?.name} />
        <meta property="og:image" content={sellItem?.nft_id?.image_id?.image?.water_mark_image_link ? sellItem?.nft_id?.image_id?.image?.water_mark_image_link : sellItem?.nft_id?.image_id?.image?.link} />
        <meta property="og:description" content={sellItem?.nft_id?.description} />
        <meta property="og:url" content={`https://${process.env.REACT_APP_DOMAIN_PREFIX}/nftsale/${sellItem?.nft_id?._id}`} />
      </Helmet>

      {(loading3) &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }

      <Modal className="EmailVerifyBoxModel buynowDialog text-center" show={buyDialog} centered animation={false}>

        <BuyNft totalPriceMatic={printInfo?.total_cost_matic} fucn={buynowBtn} saledata={saledatasend} buyType={isDigital === "Physical with Crypto" ? "Physical" : isDigital} printInfo={printInfo} ownerPriceMatic={ownerPriceMatic} printerChargeMatic={printerChargeMatic} ownerId={sellItem?.owner_id?._id} />
      </Modal>
      <Modal className="EmailVerifyBoxModel previewnftDialog text-center" show={viewnftDialog} centered animation={false}>
        <PreviewNFT fucn={viewnftBtn} nftData={nftlink} />
      </Modal>

      <Modal className="EmailVerifyBoxModel commingSoondialog text-center" size="lg" show={paywithcard} centered animation={false}>
        <PaywithCard fucn={paywithCardftBtn} />
      </Modal>

      <Header />
      <div className="profileBox nftview">

        <Row className="m-0">
          <Col lg={12}>
            <h1>DIGITAL ARTWORK SALE </h1>
          </Col>
        </Row>
      </div>
      {!empty ? (

        <div className=" nftViewBoxMaine text-start">
          
          <Container fluid className="Mainbox-bg-color pt-5">
            <Container>
              <Row>
                <Col lg={12}>

              <div className="d-flex align-items-center gap-3 tagname">
                <p className="hashTag">
                  {sellItem?.nft_id?.category_id?.name && <span>#{sellItem?.nft_id?.category_id?.name}</span>}
                  {sellItem?.nft_id?.subcategory?.name && <span> #{sellItem?.nft_id?.subcategory?.name}</span>}
                </p>
              </div>
              <h1>{sellItem?.nft_id?.name} </h1>

            </Col>
                <Col lg={12} className="mb-4 ">
                  <div className="ownednftBox">
                    <Row>
                      <Col className="mb-3" lg={7}>
                        <div className='nftviewBoxNew'>
                          <img src={sellItem?.nft_id?.image_id?.image?.water_mark_image_link ? sellItem?.nft_id?.image_id?.image?.water_mark_image_link : sellItem?.nft_id?.image_id?.image?.link} className='blurimg' alt="" />
                          <div className="ownednftImgBox cursor-pointer " onClick={() => viewnftBtn(sellItem)}>
                            <img
                              src={sellItem?.nft_id?.image_id?.image?.water_mark_image_link ? sellItem?.nft_id?.image_id?.image?.water_mark_image_link : sellItem?.nft_id?.image_id?.image?.link}
                              className="img-fluid"
                              alt=""
                            />
                            <button className="sallerBox position-absolute bottom-0 mb-2 me-2 end-0">SELLER - {sellItem?.owner_id?.role}</button>
                          </div>
                        </div>
                        <div className="d-flex gap-3 justify-content-between mt-3 mb-3">
                          <h1 className="d-flex align-items-center matic artRate gap-3 mb-2 mt-3">
                            {/* {" "}
                            <img
                              src="/images/svg/maticIcon.svg"
                              width="30"
                              height="30"
                              alt=""
                            />{" "} */}
                            {/* {sellItem?.price} POL ( {symbol + " " + (Number(usdPrice?.data)).toFixed(6)}  <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} />  ) */}
                            {symbol + " " + (Number(usdPrice?.data)).toFixed(6)}  <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} />
                          </h1>
                          <ul className="mb-3">
                            <li>

                              <button ><i className="fa-solid eye fa-eye"></i> {data?.view_count}</button>
                            </li>
                            <li>

                              {authToken ? <>  <button onClick={() => handleLikeView("like")}> {like === false ? <i className="fa-solid heart fa-heart"></i> : <i className="fa-regular fa-heart"></i>} {data?.like_count} </button></> : <button > {like === false ? <i className="fa-solid heart fa-heart"></i> : <i className="fa-regular fa-heart"></i>} {data?.like_count}</button>}
                            </li>
                            <li className="sharebtnLi">

                              <button className="shareBtn">
                                <span className="nftText"></span> <i className="fa-sharp fa-regular fa-share-nodes"></i>
                              </button>
                              <div className="shareBoxNew">
                                <Share />
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="table-responsive">
                          <table class="tabledata">
                            <tr>
                              <th className="fw-semibold mb-1">Edition Size</th>
                              <td className="fw-semibold mb-1"> {sellItem?.no_of_copies}</td>
                            </tr>
                            <tr>
                              <th className="fw-semibold mb-1">Available Artworks</th>
                              <td className="fw-semibold mb-1"> {sellItem?.available_copies}</td>
                            </tr>
                            <tr>
                              <th className="fw-semibold mb-1">Royalty percentage</th>
                              <td className="fw-semibold mb-1"> {sellItem?.loaylty} %</td>
                            </tr>

                            <tr>
                              <th className="fw-semibold pb-4">Type of Artworks</th>
                              <td className="fw-semibold pb-4"> {sellItem?.nft_id?.category_id?.name}</td>
                            </tr>
                          </table></div>

                        <div className="printStyle">
                          <h3>Select Your <span className="txtclr">Buying Option</span></h3>
                          <div className="d-flex flex-wrap gap-3 pt-3">
                            {/* <button className={`printcommon-btn ${isDigital === 'Digital+Physical' ? 'active' : ''}`} onClick={() => checkVerient('Digital+Physical')}> Digital with Physical</button> */}
                            {isPhysicalArt === false && (
                              <>

                                <button className={`printcommon-btn ${isDigital === 'Digital' ? 'active' : ''}`} onClick={() => checkVerient('Digital')}> Digital</button>


                                <button className={`printcommon-btn ${isDigital === 'Physical with Crypto' ? 'active' : ''}`} onClick={() => paywithCardftBtn()}> Physical with Credit Card</button>

                                 {/* <button className={`printcommon-btn ${isDigital === 'Physical with Crypto' ? 'active' : ''}`} onClick={() => checkVerient('Physical with Crypto')}> Physical with Credit Card</button> */}

                              </>
                            )}
                            {/* {isPhysicalArt === true &&
                              <button className={`printcommon-btn ${isDigital === 'Physical with Credit Card' ? 'active' : ''}`} onClick={() => paywithCardftBtn()}> Physical with Credit Card</button>
                            } */}

                          </div>
                        </div>
                        {(isDigital !== "Digital") && <>
                          <div className="sizeBox"><h3>Enter Your <span className="txtclr">Delivering Address</span> </h3>
                            <form>
                              <div className="form-group d-flex gap-2 m-auto w-100" onClick={fucntionToFetchCountries}>

                                <select
                                  className="form-select form-control mb-2"
                                  name="country"
                                  value={printInfo?.country?.code}
                                  onChange={(e) => handleOnChangePrintInfo("country", e.target.value)}
                                  required
                                >
                                  <option value="" disabled>Select Country</option>
                                  {countries?.map((country) => (
                                    <option key={country.code} name={country.code} value={country.code} >
                                      {country.name}
                                    </option>
                                  ))}
                                </select>

                                <select
                                  className="form-select form-control mb-2"
                                  name="state"
                                  value={printInfo?.state?.code}
                                  onChange={(e) => handleOnChangePrintInfo("state", e.target.value)}
                                  disabled={!printInfo?.country}
                                  required
                                >
                                  <option value="" disabled>Select State</option>
                                  {states?.map((state) => (
                                    <option key={state.code} name={state.code} value={state.code} >
                                      {state.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="form-group">
                                <input className="form-control mb-2" onChange={(e) => handleOnChangePrintInfo("address", e.target.value)} value={printInfo?.address} placeholder="3 Abu Ajeeba Street, Damanhur" id="Address" type="text" name="name" />
                              </div>
                              <div className="form-group d-flex gap-2 m-auto w-100">
                                <input className="form-control mb-2" onChange={(e) => handleOnChangePrintInfo("landmark", e.target.value)} value={printInfo?.landmark} type="text" id="LandMark" placeholder="LandMark" name="LandMark" />
                                <input className="form-control mb-2" onChange={(e) => handleOnChangePrintInfo("pincode", e.target.value)} value={printInfo?.pincode} type="text" id="Pincode" placeholder="Pincode" name="Pincode" />


                                <select
                                  className="form-select form-control mb-2"
                                  name="country"
                                  value={printInfo?.city}
                                  onChange={(e) => handleOnChangePrintInfo("city", e.target.value)}
                                  required
                                >
                                  <option value="" disabled>Select City</option>
                                  {citites?.map((city) => (
                                    <option key={city?.name} name={city?.name} value={city?.name} >
                                      {city?.name}
                                    </option>
                                  ))}
                                </select>

                              </div>
                            </form>
                          </div>
                          {paperSizes.length > 0 &&
                            <div className="printStyle">
                              <h3>Select <span className="txtclr">Print Option </span></h3>
                              <div className="d-flex gap-3 pt-3">
                                <button className={`printcommon-btn ${printInfo?.print_option === 'Paper' ? 'active' : ''}`} onClick={() => printOption('Paper', "A1")}> Paper</button>
                                <button className={`printcommon-btn ${printInfo?.print_option === 'Canvas' ? 'active' : ''}`} onClick={() => printOption('Canvas', "24 x 24")}> Canvas</button>

                              </div>
                            </div>}
                          {(printInfo?.print_option === "Paper") && (paperSizes.length > 0 && printInfo?.country?.name && printInfo?.state?.name) &&
                            <div className="sizeBox">
                              <h3>Select Your <span className="txtclr">Size Option</span></h3>
                              <div className="d-flex gap-3 pt-3">

                                {paperSizes?.map((item, i) =>
                                  <button key={i} className={`printcommon-btn Aforsizebtn  ${printInfo?.canvas_type === item ? "active" : ""}`} onClick={() => setPrintInfo((p) => ({ ...p, canvas_type: item, partner_id: '', total_cost: 0 }))} > {item}</button>
                                )}

                              </div>
                            </div>}

                          {(printInfo?.print_option === "Canvas") && (sizeOptions.length > 0 && printInfo?.country?.name && printInfo?.state?.name) &&
                            <div>{isDigital != 'Digital' && <div className="sizeBox">
                              <h3>Select Your <span className="txtclr">Size Option  {printInfo?.print_option === "Paper" ? "" : "(In Centimeters)"}</span></h3>
                              <div className="d-flex flex-wrap gap-3 pt-3" >
                                {sizeOptions?.map((option, ind) => (
                                  <button onClick={() => handleOnChangePrintInfo("size", option)}
                                    key={option}
                                    className={`printcommon-btn ${printInfo?.size === option ? "active" : ''}`}

                                  >
                                    {option}
                                  </button>
                                ))}
                              </div>
                            </div>}</div>
                          }
                          {printInfo?.print_option !== "Paper" &&
                            <div className="printStyle">
                              <h3>Spray</h3>
                              <div className="d-flex gap-3 pt-3">
                                <button disabled className={`printcommon-btn Aforsizebtn ${printInfo?.is_spray === true ? 'active' : ''}`} onClick={() => {

                                  setPrintInfo((p) => (
                                    { ...p, is_spray: true, total_cost: 0, partner_id: '' }))
                                  return
                                }}> Yes</button>
                                {/* <button className={`printcommon-btn Aforsizebtn ${printInfo?.is_spray === false ? 'active' : ''}`} onClick={() => {
                                  setPrintInfo((p) => ({ ...p, is_spray: false, total_cost: 0, partner_id: '' }))
                                  return
                                }}> No</button> */}
                              </div>
                            </div>}
                          <div className="printStyle">
                            <h3>Select <span className="txtclr"> Printer</span></h3>
                            <div class="table-responsive">
                              <table class="summary-table">
                                {(isDigital === "Physical with Crypto" || isDigital === "Digital+Physical" || isDigital == "Physical with Crypto" || isDigital === "Physical with Credit Card") && (Printers.length > 0) &&
                                  <>
                                    {Printers.map((item, ind) => (
                                      <tr className="price" key={ind}>
                                        <th>{item?.shop_name}</th>
                                        <td>
                                          <label htmlFor={`printer-${ind}`}>
                                            {symbol}{" "}{printerPrices[item._id] || 0}
                                          </label>
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="Radios"
                                            id={`printer-${ind}`}
                                            value={item._id}
                                            onClick={() => handlePrinterSelect(item)}
                                            checked={printInfo?.partner_id === item._id}
                                          />
                                        </td>
                                      </tr>
                                    ))}


                                  </>}
                                {Printers.length === 0 && <h5 className="text-align-center">No Printer Found</h5>}
                              </table>
                            </div>
                            {/* </div> */}
                          </div>
                        </>}


                      </Col>
                      <Col className="" lg={5}>

                        <div className="summerytxt marginbox discriptionBox"><h3>Description </h3>
                          <p className="scrollheight">
                            {sellItem?.nft_id?.description}
                          </p>
                        </div>
                        <div className="listing mb-4 mt-4">
                          <h2>Artworks History  </h2>
                          <div className="table-responsive">
                            <table className="nftlistTable nftsalehist">
                              <thead>
                                <tr>
                                  <td>Status</td>
                                  <td className="text-center">Price</td>
                                  <td>Quantity</td>
                                  <td>From</td>
                                  <td>To</td>
                                  <td>Txn.</td>
                                  <td>Date</td>
                                </tr>
                              </thead>
                              <tbody>
                                {dataAfterPagination && dataAfterPagination?.map((item, index) =>
                                  <tr>
                                    <td>
                                      {item.sale_type === "minted" ? (
                                        <div className="nfthistoryStatus minted">
                                          Minted
                                        </div>)
                                        :
                                        (<div className="nfthistoryStatus transfer">
                                          Sold
                                        </div>)
                                      }
                                    </td>
                                    <td className="text-center">{item?.price} POL</td>
                                    <td className="text-center">{item?.no_of_copies}</td>
                                    <td>{item?.from?.substring(0, 5)}.....{item?.from?.substring(item?.from?.length - 4, item?.from?.length)}</td>
                                    <td>{item?.to?.substring(0, 5)}.....{item?.to?.substring(item?.to?.length - 4, item?.to?.length)}</td>
                                    <td><a href={`https://polygonscan.com/tx/${item?.trans_hash}`} target="_blank" rel="noreferrer">{item?.trans_hash?.substring(0, 5) + "....." + item?.trans_hash?.substring(item?.trans_hash?.length - 4, item?.trans_hash?.length)}</a></td>
                                    <td> <span className="dateBox">{new Date(item?.created_date).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timezone: timezone })}</span></td>
                                  </tr>
                                )}

                              </tbody>
                            </table>
                          </div>
                        </div>
                        {dataAfterPagination.length > 0 && <Col lg={12} className="text-end">
                          <Pagination
                            className="paginationNew"
                            aria-label="Page  navigation example"
                          >
                            {values > 10 && (
                              <div>
                                <PaginationItem>
                                  <PaginationLink
                                    first
                                    href="#"
                                    onClick={() => handlePagination("<<")}
                                  />
                                </PaginationItem>
                                <PaginationItem>
                                  <PaginationLink
                                    href="#"
                                    previous
                                    onClick={() => handlePagination("<")}
                                  />
                                </PaginationItem>
                              </div>
                            )}
                            {dataLength &&
                              dataLength?.map((item) => (
                                <PaginationItem
                                  className={parseInt(item) === values / 10 ? "active" : ""}
                                >
                                  <PaginationLink
                                    href="#"
                                    onClick={() => handlePagination(item)}
                                  >
                                    {item}
                                  </PaginationLink>
                                </PaginationItem>
                              ))}
                            {values < transactions.length && (
                              <div>
                                <PaginationItem>
                                  <PaginationLink
                                    href="#"
                                    next
                                    onClick={() => handlePagination(">")}
                                  />
                                </PaginationItem>
                                <PaginationItem>
                                  <PaginationLink
                                    href="#"
                                    last
                                    onClick={() => handlePagination(">>")}
                                  />
                                </PaginationItem>
                              </div>
                            )}
                          </Pagination>
                        </Col>}

                        <div className="summerytxt marginbox">
                          {isDigital != 'Digital' && <>
                            <h3>Estimated Delivery Time</h3>
                            <div className="listStyle"><h4>Expected delivery by 7 Days </h4> </div>
                            <h3>Summary</h3>
                            <h4>{sellItem?.nft_id?.name}  </h4>
                            <div class="table-responsive">
                              <table class="summary-table">
                                <tr>
                                  <th className="texttab">Type of Digital Artwork</th>
                                  <td>{printInfo?.printStyle}</td>
                                </tr>
                                <tr>
                                  <th className="texttab">Digital Artwork Size</th>
                                  <td>{printInfo?.print_option === "Canvas" ? printInfo?.size : printInfo?.canvas_type}</td>
                                </tr>

                                <tr><th className="texttab">Print Type</th>
                                  <td>{printInfo?.print_option}</td>
                                </tr>
                                {(printInfo?.printStyle === "Digital" || printInfo?.printStyle === "Digital+Physical") &&
                                  <tr className="price">
                                    <th>Amount</th>
                                    <td>{sellItem?.price} POL</td>
                                  </tr>
                                }
                                <tr className="price">
                                  <th>Printing Charge</th>
                                  <td>{printerChargeMatic.toFixed(6) || 0} POL</td>
                                </tr>
                                <tr className="price">
                                  <th>Tax</th>
                                  <td>{printInfo?.tax} POL</td>
                                </tr>
                                <tr className="price">
                                  <th>Premium Charge</th>
                                  <td>{sellItem?.premium_print_cost || 0} POL</td>
                                </tr>
                                <tr>
                                  <td className="p-2"></td>
                                </tr>
                                <tr className="totalprice">
                                  <th>Total</th>
                                  <td>

                                    {Number(alltotalPriceInMatic || 0).toFixed(6)} POL
                                    <br />
                                    {"("} {symbol} {totalConvertedPrice || 0} {")"}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </>
                          }
                          {/* { artWorkForm && Object.keys(artWorkForm).length > 0  &&
                          <div >
                            <p className="nftlinktext authtext text-align-center mt-3"><span onClick={ViewNFT}>Certificate of Authenticity</span></p>

                            <Modal
                              className="AuthenticityBoxModel uploadimg selectArt text-center"
                              show={showNFT}
                              centered
                              animation={false}
                            >
                              

                              <ViewSaleNFT dialogOpan={ViewNFT} isPhysicalArt={isChecked} nftId={sellItem?._id} showNFT={showNFT} printerName={sellItem?.owner_id?.name + " " + sellItem?.owner_id?.lastname} nftName={sellItem?.nft_id?.name}/>
                            </Modal>

                          </div>
} */}
                          {/* <h3 className="mt-5 mb-5">Payment Option</h3> */}
                          <div className="buy-btn mt-5 mb-5">
                            {authToken ? <><button className="btn btn-secondary text-white fw-semibold m-auto" onClick={buynowBtn}>BUY NOW</button></> : <Link className="btn text-decoration-none btn-secondary text-white fw-semibold m-auto " to={"/login"}>BUY NOW</Link>}
                          </div>

                        </div>

                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="bidBox bidBoxNew aboutAuther mt-5 mb-4" id="bidBox">
                          <div className="d-flex align-items-center justify-content-between aboutseelerHead">
                            <h2>About Seller</h2>
                            <div className="sharebtnLi">
                              <button>
                                <i className="fa-sharp fa-regular fa-share-nodes"></i>
                              </button>
                              <div className="shareBoxNew">
                                <Share />
                              </div>
                            </div>
                          </div>
                          <div className="autherProfile">
                            <div className="authImg">
                              <img src={sellItem?.owner_id?.profileImage?.link} alt="" />
                            </div>
                            <div className="authDetails">
                              <h3>{sellItem?.owner_id?.name + " " + sellItem?.owner_id?.lastname}</h3>

                            </div>
                          </div>
                          <p className={"hidecontent " + (readMore === true ? 'active' : '')} id="descriptionText">
                            {sellItem?.owner_id?.description}
                          </p>
                          {sellItem?.owner_id?.description?.length > 300 &&
                            <p className="ms-auto text-secondary fw-semibold cursor-pointer " onClick={readmore}>{readMore === true ? 'Read Less' : 'Read More'}</p>}
                          <div className="d-flex align-items-center w-100 gap-3 mobileWrap">
                            <button className="btn btn-outline-dark px-4">
                              Total Views - {allSellItemNftCounts}
                            </button>
                            <Link to={`/view-profile/${sellItem?.owner_id?._id}`} className="btn btn-outline-secondary px-4">
                              View Profile
                            </Link>
                          </div>
                        </div></Col>

                    </Row>
                  </div>

                  <Row >
                    {sellItemFromCollectionData.length > 0 &&
                      <Col lg={12}>
                        <h4 className="moreCollection mt-4 mb-4">More from this collection</h4>
                      </Col>
                    }

                    {/* {sellItemFromCollectionData && sellItemFromCollectionData?.map(async(item, index) =>
                      <Col className="mb-4" lg={3}>
                        <Link className="text-decoration-none" to={`/nftsale/${item._id}`}>
                          <div className="TrandingArtistMaineBox">
                            <div className="imgBox">
                              <div className="imginn">
                                <img
                                  className="img-fluid"
                                  src={(user?._id && user?._id === item?.owner_id) ? item?.nft_id?.image_id?.image?.link : item?.nft_id?.image_id?.image?.water_mark_image_link ? item?.nft_id?.image_id?.image?.water_mark_image_link : item?.nft_id?.image_id?.image?.link}
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="contBox mt-2">
                              <div className="arthead mb-2">
                                <h2 className="productName">{item?.nft_id?.name}</h2>
                             
                                <h2 className="productName fw-normal">{symbol + " " + await mapCUrrenccyConvertor(Number(item?.price))}  <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} /></h2> 
                              </div>
                              <p>
                                {item?.nft_id?.description}
                              </p>
                              <div className="d-flex align-items-center justify-content-between mt-3">
                                <p><i className="fa-regular fa-eye"></i> <span className="fw-semibold">Views</span> {item?.view_count}</p>
                                <p><i className="fa-regular fa-heart"></i> <span className="fw-semibold">Likes</span> {item?.like_count}</p>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </Col>)
                    } */}



                    {convertedItems.map((item, index) => (
                      <Col key={item._id} className="mb-4" lg={3}>
                        <Link className="text-decoration-none" to={`/nftsale/${item._id}`}>
                          <div className="TrandingArtistMaineBox">
                            <div className="imgBox">
                              <div className="imginn">
                                <img
                                  className="img-fluid"
                                  src={
                                    user?._id === item?.owner_id
                                      ? item?.nft_id?.image_id?.image?.link
                                      : item?.nft_id?.image_id?.image?.water_mark_image_link || item?.nft_id?.image_id?.image?.link
                                  }
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="contBox mt-2">
                              <div className="arthead align-items-start mb-2">
                                <h2 className="productName mt-3">{item?.nft_id?.name}</h2>
                                <h2 className="productName mt-3 priceBoxN text-end fw-normal artRate">
                                  {symbol + " " + Number(item.convertedPrice).toFixed(4)}{" "}
                                  <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} />
                                </h2>
                              </div>
                              <p>{item?.nft_id?.description}</p>
                              <div className="d-flex align-items-center justify-content-between mt-3">
                                <p>
                                  <i className="fa-regular fa-eye"></i>{" "}
                                  <span className="fw-semibold">Views</span> {item?.view_count}
                                </p>
                                <p>
                                  <i className="fa-regular fa-heart"></i>{" "}
                                  <span className="fw-semibold">Likes</span> {item?.like_count}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </Col>
                    ))}

                  </Row>
                </Col>
              </Row>
            </Container>

          </Container>
        </div>

      ) : (<> <div className="text-center d-grid justify-content-center dataNotFound py-5">
        <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
        <h3>No Digital Artwork Found</h3>
      </div></>)
      }
      <Footer />
    </>
  );
}